import { useEffect } from 'react';

import { WorkspaceScreenBorder } from '@/components/userDashboard/workflowsCards/WorkspaceScreenBorder';
import { useWorkspaceHighlight } from '@/hooks/useWorkspaceHighlight';

export const RouteWorkspaceBorder = () => {
  const { color, active } = useWorkspaceHighlight();

  useEffect(() => {
    if (!active) {
      return;
    }
    const root = document.documentElement;
    root.style.setProperty(
      '--workspace-frame-headroom',
      'var(--spacing-workspace-frame)'
    );
    return () => {
      root.style.removeProperty('--workspace-frame-headroom');
    };
  }, [active]);

  return <WorkspaceScreenBorder color={color} />;
};
